import { useMutation } from '@tanstack/react-query';

import { ZoneRuleFormSchemaValues } from 'src/features/membershipType/formSchema';
import { ZoneRule } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/zone-rules/`;

type MutationFnType = typeof mutationFn;

interface DTO extends ZoneRuleFormSchemaValues {
    parkingId: string;
    membershipId: string;
}

const mutationFn = ({ membershipId, parkingId, ...data }: DTO): Promise<ZoneRule> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateMembershipZoneRule };
